import { render } from "./Project-6.vue?vue&type=template&id=3e995d4f"
import script from "./Project-6.vue?vue&type=script&lang=js"
export * from "./Project-6.vue?vue&type=script&lang=js"
script.render = render

export default script